import { render, staticRenderFns } from "./OrderAndPointList.vue?vue&type=template&id=35e4d252&scoped=true"
import script from "./OrderAndPointList.vue?vue&type=script&lang=js"
export * from "./OrderAndPointList.vue?vue&type=script&lang=js"
import style0 from "./OrderAndPointList.vue?vue&type=style&index=0&id=35e4d252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4d252",
  null
  
)

export default component.exports